export const normalizeNumber = (number: string) => number.replace(',', '.')

export const toComma = (number: string) => number.replace('.', ',')
